import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-sm mx-auto w-full" }
const _hoisted_2 = {
  method: "post",
  action: "https://cartero.wemake.pe/process/ye90yndyge",
  class: "gap-2 py-4"
}
const _hoisted_3 = { class: "grid grid-cols-1 gap-2 relative z-10" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "flex flex-col gap-2 mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-xl font-bold" }, " Request a quote ", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label" }, "Name", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.name) = $event)),
            type: "text",
            name: "name",
            class: "form-input w-full",
            placeholder: "Your name..."
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label" }, "Phone", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.phone) = $event)),
            type: "phone",
            name: "phone",
            class: "form-input w-full",
            placeholder: "Your phone..."
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label" }, "Email", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.email) = $event)),
            type: "email",
            name: "email",
            class: "form-input w-full",
            placeholder: "Your Email"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "ZipCode", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.zipcode) = $event)),
            type: "text",
            name: "zipcode",
            class: "form-input w-full",
            placeholder: "Your Email"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.zipcode]
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex gap-1 mt-4" }, [
        _createElementVNode("div", { class: "font-light text-sm md:col-span-2" }, [
          _createElementVNode("label", { class: "form-label" }, "Payment"),
          _createElementVNode("div", null, "Wire-transfer")
        ])
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_8, [
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-slate-500 font-semibold" }, "Pick your preferred method", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_9, [
          _createCommentVNode(" send by whatsapp "),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = (...args) => ($options.sendWhatsApp && $options.sendWhatsApp(...args))),
            type: "button",
            class: "btn btn-primary p-2 flex gap-4"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: "/img/icon--whatsapp.png",
              alt: "WhatsApp",
              class: "w-5 h-5"
            }, null, -1 /* CACHED */),
            _createTextVNode(" WhatsApp ")
          ])),
          _createCommentVNode(" send by email "),
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary bg-blue-600 p-2 flex gap-4"
          }, [
            _createCommentVNode(" email icon "),
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "size-6"
            }, [
              _createElementVNode("path", { d: "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" }),
              _createElementVNode("path", { d: "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" })
            ]),
            _createTextVNode(" Email ")
          ], -1 /* CACHED */))
        ])
      ])
    ])
  ]))
}